export default __webpack_public_path__ + "static/media/calculatorOn.7823b2ac.svg";